import Api from "@/api"

function getDefaultState() {
  return {}
}

const privateCoordinator = {
  namespaced: true,
  state: getDefaultState(),
  mutations: {
    FLUSH_STATE(state) {
      Object.assign(state, getDefaultState())
    },
  },
  actions: {
    flushState({ commit }) {
      commit("FLUSH_STATE")
    },
    sendInviteSMS(ctx, slug) {
      return Api.privateCoordinator.sendInviteSMS(slug)
    },
  },
}

export default privateCoordinator
